import Header from './common/header';
import Footer from './common/footer';
import "../globals.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import UserProvider from '../providers/UserProvider';


export default function Layout(props: any) {
  return (
    <UserProvider>
      <div className="min-h-screen flex flex-col bg-neutral-50">
        <Header common={props.common} />
        <main className="flex-1 pt-20">
          {props.children}
        </main>
        <Footer />
      </div>
    </UserProvider>
  )
}
